// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#content_outer_wrapper.no-shell {\n  padding: 0px !important;\n}", "",{"version":3,"sources":["webpack://./src/app/template/layout/layout.component.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF","sourcesContent":["#content_outer_wrapper.no-shell {\r\n  padding: 0px !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
